import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useNavigate } from "react-router-dom";
import "../../../assets/DataView/DataViewDemo.css";
import "../../../assets/DataView/index.css";
import "../../../assets/css/AccordionDemo.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import jsPDF from "jspdf";
import logoBig from "../../../assets/logo1.png";
import { FilterMatchMode } from 'primereact/api';
import { getCompany } from "../../../services/userMasterUser";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { formatDate } from "../../../constants/FormateDate";
import { companyListUpload } from "../../../services/bankListUpload";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";

export default function CompanyList() {

  const navigate = useNavigate();

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);

  const ds = useRef(null);


  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(20);
  const [loadingMore, setLoadingMore] = useState(false);

  const [fileName, setFileName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [displayCompanyUpload, setDisplayCompanyUpload] = useState(false);

  const onClickCompanyUpload = (item) => {
    setDisplayCompanyUpload(true);
  };
  const onHideCompanyUpload = () => {
    setFileName("");
    setSelectedImage(null);
    setDisplayCompanyUpload(false);
  };

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    mobile: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    emailId: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    personalName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    sector: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    location: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    state: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    createdDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState('');

  const searchByStatusData = [
    { label: "Personal Name", value: "personalName" },
    { label: "Designation", value: "designation" },
    { label: "Name", value: "name" },
    { label: "Mobile", value: "mobile" },
    { label: "Email Id", value: "emailId" },
    { label: "Company Cin No", value: "companyCinNo" },
    { label: "Location", value: "location" },
    { label: "State", value: "state" },
    { label: "Sector", value: "sector" },
    { label: "Sub Sector", value: "subSector" },
    { label: "Industry", value: "industry" },
    { label: "Revenue", value: "revenue" },
  ];

  const [searchByStatus, setSearchByStatus] = useState('name');
  const [revenueStartRage, setRevenueStartRage] = useState("");
  const [revenueEndRage, setRevenueEndRage] = useState("");

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 20,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: [],
    revenueStartRage: 0,
    revenueEndRage: 0

  };

  const fetchData = (data, append = false) => {
    setLoadingMore(true);

    getCompany(data)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs

          if (append) {
            setProducts((prev) => [...(prev || []), ...newData]);
          } else {
            setProducts(newData);
          }

          setTotalRecords(response.data.totalRecords || newData.length);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  useEffect(() => {
    fetchData({
      ...typeData,
      limit: rows,
      offset: 0
    });
  }, []);


  const onFilter = (event) => {
    setFilters(event.filters);

    let searchBy = "";
    let searchText = "";

    // Detect which column filter is applied
    Object.keys(event.filters).forEach((key) => {
      if (key !== "global" && event.filters[key]?.value) {
        searchBy = key;
        searchText = event.filters[key].value;
      }
    });

    fetchData({
      searchBy,
      searchText,
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: [],
      revenueStartRage: 0,
      revenueEndRage: 0
    });
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;

    setGlobalFilterValue(value);
    setFirst(0);
    setProducts([]);

    if (searchByStatus === "revenue") {
      return;
    }

    fetchData({
      searchBy: searchByStatus,
      searchText: value,
      limit: rows,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: [],
      revenueStartRage: 0,
      revenueEndRage: 0
    });
  };

  const handleRevenueFilter = () => {
    setFirst(0);
    setProducts([]);

    fetchData({
      searchBy: searchByStatus,
      searchText: "revenue",
      limit: rows,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: [],
      revenueStartRage: Number(revenueStartRage) || 0,
      revenueEndRage: Number(revenueEndRage) || 0
    });
  };


  const loadMore = () => {
    const newOffset = first + rows;

    fetchData(
      {
        searchBy: searchByStatus === "revenue" ? "revenue" : searchByStatus,
        searchText: searchByStatus === "revenue" ? "revenue" : globalFilterValue,
        limit: rows,
        offset: newOffset,
        sortBy: "",
        sortOrder: "desc",
        statusIn: [],
        revenueStartRage:
          searchByStatus === "revenue"
            ? Number(revenueStartRage) || 0
            : 0,
        revenueEndRage:
          searchByStatus === "revenue"
            ? Number(revenueEndRage) || 0
            : 0
      },
      true
    );

    setFirst(newOffset);
  };

  const downloadPDF = (data) => {
    if (!data || data.length === 0) return;

    const doc = new jsPDF("landscape");
    const logoImg = new Image();
    logoImg.src = logoBig;

    doc.addImage(logoImg, "PNG", 10, 5, 40, 15);
    doc.setFontSize(16);
    doc.text("CA User Data", 200, 15);

    doc.autoTable({
      head: [["ID", "Date", "Name", "Mobile", "City", "State", "Status"]],
      body: data.map((item) => [
        item.id,
        formatDate(item.createdDate),
        item.name,
        item.mobile,
        item.city,
        item.state,
        item.status ? "ACTIVE" : "INACTIVE"
      ]),
      startY: 25,
      theme: "grid",
      styles: { fontSize: 9 }
    });

    doc.save("CA-User-List.pdf");
  };

  const handleCompanyUpload = (event) => {
    event.preventDefault();
    const fileInput = event.target.querySelector('input[type="file"]');
    const uploadFile = fileInput.files[0];

    if (!uploadFile) {
      console.error("No file selected");
      return;
    }

    companyListUpload(uploadFile)
      .then((response) => {
        const Res = response.data;
        // handle the response
        if (Res.status === true) {
          successMessage("Bank List Upload Successfully " + Res.message);
          setFileName("");
          setSelectedImage(null);
          fetchData()
          setDisplayCompanyUpload(false);
        } else {
          errorMessage("Bank List Upload Failed " + Res.message);
          setFileName("");
          setSelectedImage(null);
          fetchData()
          setDisplayCompanyUpload(false);
        }
      })
      .catch((error) => {
        // handle errors
        errorMessage("Bank List Upload Failed");
        setFileName("");
        setSelectedImage(null);
        fetchData()
        setDisplayCompanyUpload(false);
      });
  };

  const handleCompanyDownload = () => {
    const link = document.createElement("a");
    link.href = "/upload_company.xlsx"; // File path inside public folder
    link.download = "upload_company.xlsx"; // Rename file on download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    setFileName(file ? file.name : ""); // Update the file name or clear it if no file is selected

    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    } else {
      setSelectedImage(null);
    }
  };

  const renderDialogCompanyUpload = () => (
    <Dialog
      header="Company Upload"
      visible={displayCompanyUpload}
      onHide={() => onHideCompanyUpload()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "50vw" }}
    >
      <div>
        <form onSubmit={handleCompanyUpload}>
          <div className="row mb-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <button
                onClick={handleCompanyDownload}
                style={{
                  padding: "10px",
                  background: "blue",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Download Sample File
              </button>
            </div>
          </div>
          <div className="row mb-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <label for="file-upload" className="custom-file-upload">
                  <i className="pi pi-upload"></i> Choose Company File
                </label>
                <input
                  id="file-upload"
                  type="file"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </div>
              <div>
                <i
                  className="pi pi-file"
                  style={{ color: "blue", fontSize: "40px" }}
                ></i>
                {fileName && (
                  <p
                    style={{
                      alignSelf: "center",
                      fontSize: 14,
                      fontWeight: 600,
                      margin: 10,
                    }}
                  >
                    {fileName}
                  </p>
                )}
              </div>
            </div>
          </div>
          {selectedImage && (
            <div className="col-md-12 text-center">
              <button
                type="submit"
                className="move-btn move-btn-blue"
              >
                Submit
              </button>
            </div>
          )}
        </form>
      </div>
    </Dialog>
  );

  const itemTemplate = (data) => {
    return (
      <div>
      </div>
    )
  }

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/masters")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Company List
                </h5>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">
                    
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={searchByStatusData}
                        value={searchByStatus}
                        onChange={(e) => {
                          setSearchByStatus(e.value);
                        }}
                      />
                    </div>
                    {searchByStatus !== "revenue" ?
                      <div className="col-md mb-2">
                        <InputText
                          type="text"
                          value={globalFilterValue}
                          onChange={onGlobalFilterChange}
                          placeholder="Keyword Search"
                        />
                      </div>

                      :

                      <>
                        <>
                          <div className="col-md mb-2">
                          <InputText
                            type="number"
                            value={revenueStartRage}
                            onChange={(e) => setRevenueStartRage(e.target.value)}
                            placeholder="Revenue From"
                          />
                          </div>

                          <div className="col-md mb-2">
                          <InputText
                            type="number"
                            value={revenueEndRage}
                            onChange={(e) => setRevenueEndRage(e.target.value)}
                            placeholder="Revenue To"
                          />
                          </div>

                          <div className="col-md mb-2">
                          <button
                            onClick={handleRevenueFilter}
                            className="move-btn move-btn-blue"
                          >
                            Apply
                          </button>
                          </div>
                        </>
                      </>
                    }

                    
                  </div>

                  <div className="row">
                    <div className="col-md">
                      <Link
                        to="/user-master/company/create"
                        className="move-btn move-btn-blue center-text"
                      >
                        Create
                      </Link>
                    </div>
                     
                       
                    <div className="col-md">
                        <i
                          onClick={() =>
                            onClickCompanyUpload(
                              "displayCompanyUpload"
                            )
                          }
                          className="pi pi-upload"
                          style={{
                            fontSize: "20px",
                            color: "#1e439b",
                            cursor: "pointer",
                          }}
                        ></i>

                      </div>
                     
                  </div>
                </div>
                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      // lazy
                      dataKey="id"
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={rows}
                      rowsPerPageOptions={[rows, rows + 50, rows + 100]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      filters={filters}
                      onFilter={onFilter}
                      // filterDisplay="row"
                      globalFilterFields={['id', 'createdDate', "name", "mobile", "emailId", "personalName", "sector", "location", "state"]}
                      stripedRows
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>
                      <Column
                        field="createdDate"
                        header="Date"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {formatDate(rowData.createdDate)}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="name"
                        header="Name"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.name}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="mobile"
                        header="Mobile No."
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.mobile}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="emailId"
                        header="Email Id"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.emailId}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="personalName"
                        header="Personal Name"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.personalName}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="designation"
                        header="Designation"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.designation}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="revenue"
                        header="Revenue"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.revenue}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="subSector"
                        header="Sub Sector"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.subSector}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="sector"
                        header="Sector"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.sector}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="location"
                        header="Location"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.location}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="state"
                        header="State"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.state}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="companyCinNo"
                        header="Company Cin No"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.companyCinNo}
                          </span>
                        )}
                      ></Column>


                      <Column
                        field="status"
                        header="Status"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData.status === "ACTIVE" ? "ACTIVE" : "INACTIVE")}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="Edit"
                        header="Edit"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/user-master/company/edit"}
                            state={rowData}
                            className="move-btn move-btn-yellow center-text"
                          >
                            Edit <i className="bi bi-pencil-square"></i>
                          </Link>
                        )}
                      ></Column>
                    </DataTable>
                    <DataScroller
                                        ref={ds} 
                                        value={products} 
                                        itemTemplate={itemTemplate} 
                                        rows={5} 
                                        loader 
                                        // footer={footer} 
                                        // header="Click Load Button at Footer to Load More" 
                                      />
                                      <div
                                        className="flex justify-content-center fixed "
                                        style={{ bottom: 30, left: 20 }}
                                      >
                                        <Button
                                          type="text"
                                          icon="pi pi-plus"
                                          // label="More"
                                          onClick={loadMore} // Update this to trigger `getData`
                                        />
                                      </div>
                                      {/*products && products.length < totalRecords && (
                                        <div style={{ textAlign: "center", margin: "20px" }}>
                                          <button
                                            onClick={loadMore}
                                            disabled={loadingMore}
                                            style={{
                                              padding: "10px 20px",
                                              backgroundColor: "#1e439b",
                                              color: "#fff",
                                              border: "none",
                                              cursor: "pointer",
                                              borderRadius: "5px"
                                            }}
                                          >
                                            {loadingMore ? "Loading..." : "Load More"}
                                          </button>
                                        </div>
                                      )*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div>{renderDialogCompanyUpload()}</div>
    </main>
  );
}
